module.exports = __webpack_public_path__ + "img/slide-offer202402-mob-gr.fbeb5fa0.png";